// src/utils/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.setAttribute("data-body-lock", "true");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.setAttribute("data-body-lock", "false");
  }
};
var body_lock_default = new bodyLock();

// src/utils/accessibility.js
function setFocusability(container, focusable) {
  if (!container)
    return;
  const focusableElements = container.querySelectorAll("a, button, input, select, textarea, [tabindex]");
  focusableElements.forEach((element) => {
    if (focusable) {
      if (element.getAttribute("tabindex") === "-1") {
        element.removeAttribute("tabindex");
      }
    } else {
      element.setAttribute("tabindex", "-1");
    }
  });
}

// src/utils/cart-drawer.js
var cartDrawerElement = document.querySelector("#cart-drawer-holder");
var curtain = document.querySelector("#cart-curtain");
var cartDrawerOpener = document.querySelector(".cart-drawer-opener");
var closeDrawerOpener = document.querySelector(".close-cart-drawer");
var cartDrawer = class _cartDrawer {
  constructor() {
    if (cartDrawerElement) {
      if (cartDrawerOpener) {
        cartDrawerOpener.addEventListener("click", this.openCartDrawer);
      }
      if (closeDrawerOpener) {
        closeDrawerOpener.addEventListener("click", _cartDrawer.closeCartDrawer);
      }
    }
  }
  /**
   * Get current state of the cart drawer.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState() {
    if (cartDrawerElement.getAttribute("aria-hidden") === "false") {
      return {
        state: "open",
        isCartOpen: true
      };
    } else {
      return {
        state: "closed",
        isCartOpen: false
      };
    }
  }
  /**
   * Open cart drawer.
   */
  openCartDrawer() {
    cartDrawerElement.setAttribute("aria-hidden", "false");
    curtain.setAttribute("aria-hidden", "false");
    setFocusability(cartDrawerElement, true);
    body_lock_default.lock();
  }
  /**
   * Close cart drawer.
   */
  static closeCartDrawer() {
    cartDrawerElement.setAttribute("aria-hidden", "true");
    curtain.setAttribute("aria-hidden", "true");
    setFocusability(cartDrawerElement, false);
    body_lock_default.unlock();
  }
  /**
   * Handle open cart drawer.
   */
  handleCartDrawerState() {
    const currentState = this.getCurrentState();
    if (currentState.isCartOpen) {
      _cartDrawer.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }
  /**
   * Close the cart drawer when clicked outside the cart drawer.
   */
  static hideOnClickOutside() {
    const outsideClickListener = (event) => {
      const target = event.target;
      if (target !== cartDrawerElement && target.closest(".cart-drawer") || target.closest(".cart-drawer-opener") === cartDrawerOpener) {
      } else {
        this.closeCartDrawer();
        removeClickListener();
      }
    };
    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener);
    };
    document.addEventListener("click", outsideClickListener);
  }
};
var cart_drawer_default = new cartDrawer();

// src/extenders/cart-drawer.js
function initCartDrawer() {
  const close = document.querySelector("#cart-drawer-close");
  const curtain2 = document.querySelector("#cart-curtain");
  const toggle = document.querySelector("#cart-toggle");
  close == null ? void 0 : close.addEventListener("click", () => {
    cart_drawer_default.handleCartDrawerState();
  });
  curtain2 == null ? void 0 : curtain2.addEventListener("click", () => {
    cart_drawer_default.handleCartDrawerState();
  });
  toggle == null ? void 0 : toggle.addEventListener("click", () => {
    cart_drawer_default.handleCartDrawerState();
  });
}
document.addEventListener("DOMContentLoaded", initCartDrawer);
